import { GENERIC_EVENT_NAME } from './constants';
import { GenericAnalyticsEvent } from './types';

const trackEvent = async (data: GenericAnalyticsEvent) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

const trackUserInit = (payload: any) => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'user_init',
    properties: payload,
  });
};

const trackStartSearch = (payload: any) => {
  trackEvent({
    event: GENERIC_EVENT_NAME,
    name: 'start_search',
    properties: payload,
  });
};

export { trackEvent, trackUserInit, trackStartSearch };
